import { lazy, Suspense } from 'react'
import {
  Route,
  Switch,
  BrowserRouter as Router
} from 'react-router-dom'
const Home = lazy(() => import('./pages/home'));
const Mitra = lazy(() => import('./pages/mitra'));
const Karir = lazy(() => import('./pages/karir'));
const Blog = lazy(() => import('./pages/blog'));
const BlogDetail = lazy(() => import('./pages/blog-detail'));
const Program = lazy(() => import('./pages/program'));
const ProgramDetail = lazy(() => import('./pages/program-detail'));
const Products = lazy(() => import('./pages/products'));
const Faq = lazy(() => import("./pages/faq"));
const Jual = lazy(() => import("./pages/jual"));
const Contact = lazy(() => import("./pages/contact"));
const About = lazy(() => import("./pages/about"));
const Term = lazy(() => import("./pages/term"));
const Privacy = lazy(() => import("./pages/privacy"));
const FormMitra = lazy(() => import("./pages/form-mitra"));
// import './App.css';



function App() {
  return (
    
      <Router basename="/kepul-website">
        <Suspense fallback={'loading ...'}>
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/mitra/:query' exact component={Mitra} />
            <Route path='/karir' exact component={Karir} />
            <Route path='/blog' exact component={Blog} />
            <Route path="/blog/:id" exact component={BlogDetail} />
            <Route path='/program' exact component={Program} />
            <Route path="/program-detail/:id" exact component={ProgramDetail} />
            <Route path='/all-produts' exact component={Products} />
            <Route path='/faq' exact component={Faq} />
            <Route path='/jual-di-kepul' exact component={Jual} />
            <Route path='/contact-us' exact component={Contact} />
            <Route path='/about' exact component={About} />
            <Route path='/term-and-condition' exact component={Term} />
            <Route path='/privacy-police' exact component={Privacy} />
            <Route path='/form-mitra' exact component={FormMitra} />
          </Switch>
        </Suspense>
      </Router>
    

  );
}

export default App;
